import { useContext } from 'react'
import {
  AlertContext,
  type AlertContextValue,
} from '@/components/alerts/alert.context.ts'

export function useAlert(): AlertContextValue {
  const context = useContext(AlertContext)
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider')
  }
  return context
}
